import React from 'react';
import { BeforeAuthHeader, Footer } from '../../components/commons';
import { ForgotPasswordCard } from '../../components/ForgotPassword';

const ForgotPassword = () => {
  return (
    <>
      <BeforeAuthHeader />
      <div className="container">
        <ForgotPasswordCard />
      </div>
      <Footer />
    </>
  )
};

export default ForgotPassword;